/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineWithoutModule200,
  GetApiV1ClassroomdisciplineWithoutModule400,
  GetApiV1ClassroomdisciplineWithoutModule401,
  GetApiV1ClassroomdisciplineWithoutModule404,
  GetApiV1ClassroomdisciplineWithoutModule500,
  GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineWithoutModule.ts";
import { disciplineClassesViewModelSchema } from "../disciplineClassesViewModelSchema.ts";

export const getApiV1ClassroomdisciplineWithoutModuleQueryParamsSchema = z
  .object({
    disciplineId: z.optional(z.coerce.number().int()),
    startDate: z.optional(z.string().datetime()),
    endDate: z.optional(z.string().datetime()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModuleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineWithoutModule200Schema = z.lazy(
  () => disciplineClassesViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModule200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ClassroomdisciplineWithoutModule400Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModule400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineWithoutModule401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModule401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineWithoutModule404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModule404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineWithoutModule500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModule500>;

export const getApiV1ClassroomdisciplineWithoutModuleQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineWithoutModule200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineWithoutModuleQueryResponse>;
